<div
  class="pricing-dropdown-container"
  *ngFor="let pricing of pricingInfo; let i = index"
>
  <!-- disable expansion animation due to bug with it being nested in another component -->
  <!-- https://github.com/angular/material2/issues/11765 -->
  <mat-accordion [@.disabled]="true">
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ pricing.label }}
        </mat-panel-title>
        <mat-panel-description>
          <span *ngIf="_input?.name">{{ sumOfPriceBreakdown[i] }}</span>
          <span *ngIf="!_input?.name">Please select state</span>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <div>
        <div class="price-breakdown">
          <mat-list *ngFor="let p of pricing.pricingDetail">
            <mat-list-item>
              <div>
                <span class="price-item-title">{{ p.label }}</span>
                <span *ngIf="p.note" class="info-text">
                  {{ _input.name }}
                </span>
                <mat-icon
                  *ngIf="p.note"
                  class="info-text"
                  matTooltip="{{ p.note }}"
                >
                  info_outline
                </mat-icon>
              </div>
              <div>
                <strong>{{ p.pricingFunc(_input.code) | price: 'USD' }}</strong>
              </div>
            </mat-list-item>
          </mat-list>
        </div>
        <div class="price-total-border"></div>
        <div class="line-total">
          <div class="total">Total</div>
          <div *ngIf="_input?.name">{{ sumOfPriceBreakdown[i] }}</div>
          <div *ngIf="!_input?.name">Please select state</div>
        </div>
        <div *ngIf="pricing.note" class="renewal-notes">
          {{ pricing.note }}
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
